export default {
    title: 'Layout and Structure/USA Banner',
    tags: ['beta'],
  };
  
const Template = () => {
  return ` 
      <cbp-usa-banner></cbp-usa-banner>
    `;
};

export const usabanner = Template.bind({});
usabanner.storyName="USA Banner"
